'use client';

import { useEffect } from 'react';

import Divider from '../../components/Divider';
import { MAX_WIDTH_639PX } from '../../utils/common';
import { CommunityGtm } from '../../utils/gtm/community/communityGtm';
import useClientMediaQuery from '../../utils/hook/useClientMediaQuery';
import { useRouterQuery } from '../../utils/hook/useRouterQuery';
import RecipeSearchPopup from '../components/recipe/components/RecipeSearchPopup';
import LatestRecipeCuration from '../components/recipe/main/LatestRecipeCuration';
import MonthlyRecommendedRecipeCuration from '../components/recipe/main/MonthlyRecommendedRecipeCuration';
import OriginalRecipeCuration from '../components/recipe/main/OriginalRecipeCuration';
import PersonalRecipeCuration from '../components/recipe/main/PersonalRecipeCuration';
import RecipeHeader from '../components/recipe/main/RecipeHeader';
import RecipeMainBlogs from '../components/recipe/main/RecipeMainBlogs';
import RecipeMainCertifiedCreators from '../components/recipe/main/RecipeMainCertifiedCreators';
import RecipeMainDiaries from '../components/recipe/main/RecipeMainDiaries';

const RecipePage = () => {
  const isMobile = useClientMediaQuery({ query: MAX_WIDTH_639PX });
  const {
    query: { search },
  } = useRouterQuery<{ search?: true }>();

  const isShowingSearchPopup = isMobile && !!search;

  useEffect(() => {
    new CommunityGtm().visit_community_page();
  }, []);

  return (
    <div className="mx-auto max-w-screen-lg pt-24px pb-48px">
      <RecipeHeader />

      <Divider className="my-40px" />
      <MonthlyRecommendedRecipeCuration />

      <Divider className="my-40px" />
      <RecipeMainDiaries />

      <Divider className="my-40px" />
      <RecipeMainCertifiedCreators />

      <Divider className="my-40px" />
      <RecipeMainBlogs />

      <Divider className="my-40px" />
      <div className="flex flex-col gap-40px">
        <PersonalRecipeCuration />
        <OriginalRecipeCuration />
      </div>

      <Divider className="mb-40px mt-40px sm:mt-56px" />
      <LatestRecipeCuration />
      {isShowingSearchPopup && <RecipeSearchPopup />}
    </div>
  );
};

export default RecipePage;
